import type { SVGProps } from "react";
import * as React from "react";

export const CircleIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 12 12"
    className="fill-current"
    {...props}
  >
    <circle
      cx={6}
      cy={6}
      r={6}
      fill="currentColor"
    />
  </svg>
);
